/**
 * @fileoverview Copied from https://github.com/zamicol/BaseConverter
 */

// baseConvert converts a given string with a given encoding alphabet
//
//
// Base is assumed from alphabet sizes.

const prePadZero = (val, length) => {
  val += ''
  while (val.length < 6) val = '0' + val
  return val
}

/**
 * baseConvert converts a given string with a given encoding alphabet
 * into another base with another given encoding alphabet.
 * Base is assumed from alphabet sizes.
 * @param  {string} str The string to be encoded into another base.
 * @param  {string} inputAlphabet The characters of the input alphabet (i.e. 0123456789ABCDEF)
 * @param  {string} outputAlphabet The characters of the output alphabet (i.e. ABCDEFGHJKLMNPQRSTUVWXYZ234567)
 */
export function baseConvert(str, inputAlphabet, outputAlphabet) {
  if (str == '' || inputAlphabet == '' || outputAlphabet == '') {
    return null
  }

  // The previous base convert code was not performant when you had a lot of
  // missions so instead we'll just convert chunks from bits to a single char,
  // we lose a bit of compression but it should be performant
  // Keeping function signature the same to avoid refactoring other code.
  var validAlphabet =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'
  var valid =
    (inputAlphabet == '01' && outputAlphabet.startsWith(validAlphabet)) ||
    (inputAlphabet.startsWith(validAlphabet) && outputAlphabet == '01')
  if (!valid) throw new Error('Alphabet not supported.')
  if (inputAlphabet == '01') return encodeStr(str)
  else return decodeStr(str)
}

function encodeStr(str) {
  var alphabet =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'
  var encodedStr = ''
  var byteSize = 6
  let totalLeadingZeros = 0
  while (str.length) {
    var temp = str.slice(-byteSize)
    str = str.slice(0, -6)
    if (!str.length) {
      totalLeadingZeros = 6 - temp.length
    }
    var index = parseInt(temp, 2)
    var val = alphabet[index]
    encodedStr = val + encodedStr
  }
  encodedStr += totalLeadingZeros
  return encodedStr
}

function decodeStr(str) {
  var alphabet =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'
  var decodedStr = ''
  var totalLeadingZeros = Number(str.slice(-1))
  str = str.slice(0, -1)
  while (str.length) {
    var temp = str.slice(-1)
    str = str.slice(0, -1)
    var index = Array.prototype.findIndex.call(alphabet, c => c == temp)
    var val = prePadZero(index.toString(2))
    decodedStr = val + decodedStr
  }
  return decodedStr.slice(totalLeadingZeros)
}
